const SCROLL_THRESHOLD = 100;
const SCROLL_LOCK_CLASS = 'disabled-scroll';
const TEMPLATE_SELECTOR = '#scrolling-nav-template';
const NAV_SELECTOR = '#scrolling-nav';
const NAV_INNER_SELECTOR = '.scrolling-nav-inner';
const MOBILE_BREAKPOINT = 768;

const ACTIVE_CLASSES = ['text-green', 'border-green', 'font-semibold'];
const INACTIVE_CLASSES = ['text-grey-600', 'border-transparent'];

const scrollNavToCenter = (container, activeItem) => {
  if (window.innerWidth >= MOBILE_BREAKPOINT) return;

  const containerRect = container.getBoundingClientRect();
  const itemRect = activeItem.getBoundingClientRect();
  const scrollLeft = container.scrollLeft
    + (itemRect.left - containerRect.left)
    - (containerRect.width / 2)
    + (itemRect.width / 2);

  container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
};

export const scrollToSection = (selector) => {
  const target = document.querySelector(selector);
  if (!target) return;

  const navEl = document.querySelector(NAV_SELECTOR);
  const navHeight = navEl ? navEl.offsetHeight : 0;

  const top = target.getBoundingClientRect().top + window.scrollY - navHeight;

  window.scrollTo({ top, behavior: 'smooth' });
};

const renderNavItems = (container, sections, trackingEventName) => {
  sections.forEach((section) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = section.label;
    button.dataset.section = section.selector;
    button.className = [
      'whitespace-nowrap',
      'text-sm',
      'border-0',
      'border-b-2',
      'border-solid',
      'bg-transparent',
      'cursor-pointer',
      'transition-colors',
      'duration-200',
      ...INACTIVE_CLASSES,
    ].join(' ');

    button.addEventListener('click', () => {
      scrollToSection(section.selector);

      const allButtons = container.querySelectorAll('button');
      allButtons.forEach((btn) => {
        if (btn === button) {
          btn.classList.remove(...INACTIVE_CLASSES);
          btn.classList.add(...ACTIVE_CLASSES);
        } else {
          btn.classList.remove(...ACTIVE_CLASSES);
          btn.classList.add(...INACTIVE_CLASSES);
        }
      });
      scrollNavToCenter(container, button);

      const resetAll = () => {
        allButtons.forEach((btn) => {
          btn.classList.remove(...ACTIVE_CLASSES);
          btn.classList.add(...INACTIVE_CLASSES);
        });
      };

      const clearTimer = setTimeout(resetAll, 5000);

      let scrollEndTimeout = null;
      let programmaticScrollEnded = false;

      const onScroll = () => {
        clearTimeout(scrollEndTimeout);
        scrollEndTimeout = setTimeout(() => {
          if (!programmaticScrollEnded) {
            programmaticScrollEnded = true;
            return;
          }
          window.removeEventListener('scroll', onScroll);
          clearTimeout(clearTimer);
          resetAll();
        }, 150);
      };

      window.addEventListener('scroll', onScroll, { passive: true });

      App.track.event(trackingEventName, {
        section: 'scrolling_nav_bar',
        element: 'section_title',
        element_value: section.label,
        interaction: 'click',
      });
    });

    container.appendChild(button);
  });
};

const initShowHide = (navEl) => {
  const onScroll = () => {
    if (document.documentElement.classList.contains(SCROLL_LOCK_CLASS)) {
      return;
    }
    if (window.scrollY > SCROLL_THRESHOLD) {
      navEl.classList.remove('-translate-y-full');
    } else {
      navEl.classList.add('-translate-y-full');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
};

/**
 * @param {Object} config
 * @param {Array<{label: string, selector: string}>} config.sections
 * @param {string} config.trackingEventName
 */
const hydrateTemplate = () => {
  const template = document.querySelector(TEMPLATE_SELECTOR);
  if (!template) return null;

  document.body.insertAdjacentHTML('beforeend', template.innerHTML);
  return document.querySelector(NAV_SELECTOR);
};

export const initScrollingNav = (config) => {
  const navEl = hydrateTemplate();
  if (!navEl) return;

  const navInner = navEl.querySelector(NAV_INNER_SELECTOR);
  if (!navInner) return;

  const presentSections = config.sections.filter((section) => {
    const el = document.querySelector(section.selector);
    return el && el.offsetParent !== null;
  });

  if (presentSections.length === 0) return;

  renderNavItems(navInner, presentSections, config.trackingEventName);
  initShowHide(navEl);
};
